import { Close, type CloseProps } from './Close';
import { Content, type ContentProps } from './Content';
import { ContentBody, type ContentBodyProps } from './ContentBody';
import { ContentHeader, type ContentHeaderProps } from './ContentHeader';
import { Overlay, type OverlayProps } from './Overlay';
import { Portal, type PortalProps } from './Portal';
import { Root, type RootProps } from './Root';
import { Title, type TitleProps } from './Title';
import { Trigger, type TriggerProps } from './Trigger';

export {
  Root,
  type RootProps,
  Portal,
  type PortalProps,
  Overlay,
  type OverlayProps,
  Content,
  type ContentProps,
  ContentHeader,
  type ContentHeaderProps,
  Close,
  type CloseProps,
  ContentBody,
  type ContentBodyProps,
  Title,
  type TitleProps,
  Trigger,
  type TriggerProps,
};
